exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".p6-Fy>div{width:100%}.p6-Fy>div>div{align-self:start}.p6-Fy ._3ziA1{width:1px;height:275px;background-color:#dfe5eb;float:left}.p6-Fy ._7oHr_{display:inline-block}.p6-Fy ._3RplX{display:inline-block;padding-left:5px;position:relative;top:-3px}\n", ""]);

// Exports
exports.locals = {
	"categories": "p6-Fy",
	"divider": "_3ziA1",
	"headline": "_7oHr_",
	"infoIcon": "_3RplX"
};